import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/print.css'
import './lib/amplify' // Initialize Amplify
import App from './App.tsx'
import { HeadProvider } from 'react-head'

import LogRocket from 'logrocket'
import { env } from './config/env.ts'

LogRocket.init(env.logrocketAppId, {
  shouldDebugLog: env.isDev,
  console: {
    isEnabled: {
      log: false,
      debug: false,
    },
  },
})

// Register service worker
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    // Import the worker with Vite's worker syntax to get the bundled URL
    import('./workers/pingWorker?worker&url').then(module => {
      navigator.serviceWorker
        .register(module.default, { type: 'module' })
        .then(registration => {
          console.log(
            'ServiceWorker registration successful:',
            registration.scope,
          )
        })
        .catch(error => {
          console.error('ServiceWorker registration failed:', error)
        })
    })
  })
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HeadProvider>
      <App />
    </HeadProvider>
  </React.StrictMode>,
)
